export default {
  base: 'Standard',
  LDAP: 'LDAP',
  loginWithCAS: 'Login with CAS',
  loginWithSAML: 'Login with SAML',
  loginWithOauth: 'Login with OAuth2/OpenID',
  documentation: 'Documentation',
  forum: 'Forum',
  website: 'Canopsis.com',
  connectionProtocols: 'Connection protocols',
  errors: {
    incorrectEmailOrPassword: 'Incorrect email or password',
    underMaintenance: 'Canopsis is under maintenance',
  },
};
